import { Button } from '@teamsparta/stack-button';
import { ActionShare } from '@teamsparta/stack-icons';
import { vars } from '@teamsparta/stack-tokens';

interface Props {
  onClick?: () => void;
}

export function ShareButton({ onClick }: Props) {
  return (
    <Button
      leftAddon={<ActionShare size={16} color={vars.neutral[5]} />}
      size='sm'
      colorScheme='secondary'
      variant='outline'
      style={{ width: 100 }}
      onClick={onClick}
    >
      공유
    </Button>
  );
}
